//AUTH
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const TOGGLE_USER_LOADING = "TOGGLE_USER_LOADING";
export const TOGGLE_USER_UPDATE = "TOGGLE_USER_UPDATE";
export const UPDATE_USER = "UPDATE_USER";

// ARTICLES
export const GET_PUBLIC_ARTICLES = "GET_PUBLIC_ARTICLES";
export const GET_PRIVATE_ARTICLES = "GET_PRIVATE_ARTICLES";
export const POST_NEW_ARTICLE = "POST_NEW_ARTICLE";
export const UPDATE_ARTICLE = "UPDATE_ARTICLE";
export const DELETE_ARTICLE = "DELETE_ARTICLE";
export const TOGGLE_ARTICLE = "TOGGLE_ARTICLE";
export const ADMIN_DETAILS_ARTICLE = "ADMIN_DETAILS_ARTICLE";
export const PUBLIC_DETAILS_ARTICLE = "PUBLIC_DETAILS_ARTICLE";
export const GET_ARTICLES_BY_TAG = "GET_ARTICLES_BY_TAG";
export const GET_ARTICLES_BY_CATEGORY = "GET_ARTICLES_BY_CATEGORY";
export const ADD_LIKE = "ADD_LIKE";
export const GET_ARTICLE_BY_LINK = "GET_ARTICLE_BY_LINK";
export const TOGGLE_ARTICLE_LOADING = "TOGGLE_ARTICLE_LOADING";
export const TOGGLE_LIKE_ADDING = "TOGGLE_LIKE_ADDING";
export const ARTICLES_LOADING = "ARTICLES_LOADING";
export const SAVE_DRAFT_START = "SAVE_DRAFT_START";
export const SAVE_DRAFT_SUCCESS = "SAVE_DRAFT_SUCCESS";
export const SAVE_DRAFT_ERROR = "SAVE_DRAFT_ERROR";
export const PUBLISH_DRAFT = "PUBLISH_DRAFT";
export const LINK_ARTICLES = "LINK_ARTICLES";
export const UNLINK_ARTICLES = "UNLINK_ARTICLES";


// CHEATSHEETS
export const GET_PUBLIC_CHEATSHEETS = "GET_PUBLIC_CHEATSHEETS"
export const GET_PRIVATE_CHEATSHEETS = "GET_PRIVATE_CHEATSHEETS"
export const POST_NEW_CHEATSHEET = "POST_NEW_CHEATSHEET"
export const UPDATE_CHEATSHEET = "UPDATE_CHEATSHEET"
export const DELETE_CHEATSHEET = "DELETE_CHEATSHEET"
export const TOGGLE_CHEATSHEET = "TOGGLE_CHEATSHEET"
export const GET_CHEATSHEETS_BY_TAG = "GET_CHEATSHEETS_BY_TAG"
export const GET_CHEATSHEETS_BY_CATEGORY = "GET_CHEATSHEETS_BY_CATEGORY"
export const ADMIN_DETAILS_CHEATSHEET = "ADMIN_DETAILS_CHEATSHEET"
export const PUBLIC_DETAILS_CHEATSHEET = "PUBLIC_DETAILS_CHEATSHEET"
export const GET_CHEATSHEET_BY_LINK = "GET_CHEATSHEET_BY_LINK"
export const CHEATSHEET_LOADING = "CHEATSHEET_LOADING"


// TEXT
export const GET_PRIVATE_TEXT_DETAIL = "GET_PRIVATE_TEXT_DETAIL";
export const GET_PUBLIC_TEXT_DETAIL = "GET_PUBLIC_TEXT_DETAIL";
export const UPDATE_TEXT = "UPDATE_TEXT";
export const TOGGLE_TEXT = "TOGGLE_TEXT";

//CONTACT
export const GET_ALL_CONTACTS = "GET_ALL_CONTACTS";
export const POST_NEW_CONTACT = "POST_NEW_CONTACT";
export const TOGGLE_CONTACT = "TOGGLE_CONTACT";

//SUBSCRIBE
export const POST_SUBSCRIBE = "POST_SUBSCRIBE";
export const GET_ALL_SUBSCRIBE = "GET_ALL_SUBSCRIBE";
export const TOGGLE_SUBSCRIBE = "TOGGLE_SUBSCRIBE";
export const RESET_SUBSCRIBE = "RESET_SUBSCRIBE";

// DATA
export const GET_ALL_CATEGORIES = "GET_ALL_CATEGORIES";
export const ADD_CATEGORY = "ADD_CATEGORY";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const DELETE_ALL_CATEGORIES = "DELETE_ALL_CATEGORIES";
export const GET_CATEGORY_BY_ID = "GET_CATEGORY_BY_ID";
export const GET_ALL_TAGS = "GET_ALL_TAGS";


// PROJECTS
export const GET_PUBLIC_PROJECTS = "GET_PUBLIC_PROJECTS";
export const GET_PRIVATE_PROJECTS = "GET_PRIVATE_PROJECTS";
export const POST_NEW_PROJECT = "POST_NEW_PROJECT";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const TOGGLE_PROJECT = "TOGGLE_PROJECT";

// SKILLS
export const GET_PUBLIC_SKILLS = "GET_PUBLIC_SKILLS";
export const GET_PRIVATE_SKILLS = "GET_PRIVATE_SKILLS";
export const POST_NEW_SKILL = "POST_NEW_SKILL";
export const UPDATE_SKILL = "UPDATE_SKILL";
export const DELETE_SKILL = "DELETE_SKILL";
export const TOGGLE_SKILL = "TOGGLE_SKILL";

// COMMENTS
export const GET_PUBLIC_COMMENTS = "GET_PUBLIC_COMMENTS";
export const GET_ADMIN_COMMENTS = "GET_ADMIN_COMMENTS";
export const POST_NEW_COMMENT = "POST_NEW_COMMENT";
export const TOGGLE_COMMENT_VISIBILITY = "TOGGLE_COMMENT_VISIBILITY";
export const DELETE_COMMENT = "DELETE_COMMENT";
export const TOGGLE_COMMENT_LOADING = "TOGGLE_COMMENT_LOADING";

// TOGGL
export const GET_TOGGL_DATA = "GET_TOGGL_DATA";

// ANALYTICS
export const GET_ANALYTICS = "GET_ANALYTICS";
export const GET_EXCLUDED_IPS = "GET_EXCLUDED_IPS";
export const ADD_EXCLUDED_IP = "ADD_EXCLUDED_IP";
export const DELETE_EXCLUDED_IP = "DELETE_EXCLUDED_IP";
export const GET_MORE_VISITS = "GET_MORE_VISITS";
export const VISITS_LOADING = "VISITS_LOADING";

// CONTENT INSIGHTS
export const GET_INSIGHTS = "GET_INSIGHTS";
export const GET_INSIGHT_DETAIL = "GET_INSIGHT_DETAIL";
export const GENERATE_INSIGHT = "GENERATE_INSIGHT";
export const DELETE_INSIGHT = "DELETE_INSIGHT";
export const INSIGHTS_LOADING = "INSIGHTS_LOADING";

// CONTENT PLANNER
export const GET_CONTENT_ITEMS = "GET_CONTENT_ITEMS";
export const CREATE_CONTENT_ITEM = "CREATE_CONTENT_ITEM";
export const UPDATE_CONTENT_ITEM = "UPDATE_CONTENT_ITEM";
export const UPDATE_CONTENT_STEP = "UPDATE_CONTENT_STEP";
export const DELETE_CONTENT_ITEM = "DELETE_CONTENT_ITEM";
export const GET_TIMELINE = "GET_TIMELINE";
export const GET_DELAYS = "GET_DELAYS";
export const GET_METRICS = "GET_METRICS";
export const CONTENT_LOADING = "CONTENT_LOADING";
export const NOTION_SEARCH_RESULTS = "NOTION_SEARCH_RESULTS";
export const NOTION_LOADING = "NOTION_LOADING";

// ADMIN CURRENT FOCUS
export const GET_ALL_FOCUSES = "GET_ALL_FOCUSES";
export const CREATE_FOCUS = "CREATE_FOCUS";
export const UPDATE_FOCUS = "UPDATE_FOCUS";
export const DELETE_FOCUS = "DELETE_FOCUS";

// NOTION BROWSING
export const GET_NOTION_PAGES = "GET_NOTION_PAGES";
export const NOTION_PAGES_LOADING = "NOTION_PAGES_LOADING";
export const CREATE_ITEM_FROM_NOTION = "CREATE_ITEM_FROM_NOTION";
export const SET_PUBLISH_DATE = "SET_PUBLISH_DATE";
export const SET_ITEM_STATUS = "SET_ITEM_STATUS";
export const RETRY_SYNC = "RETRY_SYNC";

// SERIES
export const GET_SERIES = "GET_SERIES";
export const GET_ADMIN_SERIES = "GET_ADMIN_SERIES";
export const CREATE_SERIES = "CREATE_SERIES";
export const UPDATE_SERIES = "UPDATE_SERIES";
export const DELETE_SERIES = "DELETE_SERIES";

// PUBLIC CONTENT PLANNING
export const GET_CURRENT_FOCUS = "GET_CURRENT_FOCUS";
export const GET_UPCOMING_CONTENT = "GET_UPCOMING_CONTENT";
export const GET_RECENT_PUBLISHED = "GET_RECENT_PUBLISHED";
export const PUBLIC_CONTENT_LOADING = "PUBLIC_CONTENT_LOADING";

// TAGS (admin)
export const GET_ADMIN_TAGS = "GET_ADMIN_TAGS";
export const TAGS_LOADING = "TAGS_LOADING";

//ERROR
export const SET_ERRORS = "SET_ERRORS";
